import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NiceDrawerModule, NiceLayoutModule, NiceNavigationModule } from "@recursyve/nice-ui-kit.v2";
import { NavbarModule } from "./components/navbar/navbar.module";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { DashboardComponent } from "./dashboard.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        ToolbarComponent,
        FlexLayoutModule,
        NiceDrawerModule,
        NavbarModule,
        NiceNavigationModule,
        NiceLayoutModule
    ],
    declarations: [DashboardComponent]
})
export class DashboardModule {}
